<div class="container">
    <app-generic-notification
    [titleNotification]="'Adjuntar comentario para'"
    [showCost]="false"
    [commentButton]="true"
    [declineButton]="false"
    [showMantenanceType]="false"
    [showResponsibles]="false"
    (addComment)="addComment($event)">
    </app-generic-notification>
    </div>
